import React from 'react';
import Header from './Header';
import Sidebar from './Sidebar';
import PageWrapper from './PageWrapper';

interface CashierLayoutProps {
  children: React.ReactNode;
}

const CashierLayout: React.FC<CashierLayoutProps> = ({ children }) => {
  return (
    <div className="flex min-h-screen bg-background text-text font-sans antialiased">
      <div className="flex-1 flex flex-col overflow-hidden">
        <Header />
        <main className="flex-1 overflow-y-auto p-1 md:p-20 lg:p-20 custom-scrollbar">
          <PageWrapper>
            {children}
          </PageWrapper>
        </main>
      </div>
    </div>
  );
};

export default CashierLayout;